import { DescriptionOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';

const route = 'management';

export const getManagerRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const { isActivityLeader, isProgramManager, isVmAdmin } = userIdentityService;
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;

  return {
    route,
    heading: 'Management',
    Icon: DescriptionOutlined,
    isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
    items: [
      {
        label: 'Dashboard',
        route: 'dashboard',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.insights : false
      },
      {
        label: 'Activity Management',
        route: 'activity-management',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        label: 'Rosters',
        route: 'rosters',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        label: 'Volunteers',
        route: 'volunteers',
        isAuthorized: isProgramManager || isVmAdmin,
      },
      {
        label: 'Bulletins',
        route: 'bulletins',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.bulletins : false
      },
      {
        label: 'Report Management',
        route: 'report-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false
      },
      {
        label: 'Incident Management',
        route: 'incident-management',
        isAuthorized: isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.incidents : false
      },
      {
        label: 'Program Management',
        route: 'program-management',
        isAuthorized: isProgramManager,
      },
    ],
  };
};
